import { FONTS, COLORS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minXs = theme.breakpoints.up('xs');
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');
  const minLg = theme.breakpoints.up('lg');

  const maxSm = theme.breakpoints.down('sm');
  const maxMd = theme.breakpoints.down('md');

  return {
    root: {
      width: '100%',
    },
    serviceAreasCardContent: {
      padding: '0px',
      paddingBottom: '0px !important',
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
    },
    buttonActive: {
      backgroundColor: '#4d4d4d',
      color: '#ffffff !important',
    },
    cardHeaderRoot: {
      backgroundColor: COLORS.GREY_DARK,
    },
    cardHeaderTitle: {
      color: COLORS.WHITE,
      textAlign: 'center',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    stateSelectContain: {
      display: 'flex',
    },
    stateSelect: {
      flex: '1',
    },
    serviceAreaContain: {
      justifyContent: 'space-between',
      [minSm]: {
        width: '100%',
      },
      display: 'flex',
      flexDirection: 'column-reverse',
      [minMd]: {
        flexDirection: 'row',
      },
    },
    serviceAreaForm: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      [minXs]: {
        padding: '10px',
      },
      [minSm]: {
        padding: '30px',
      },
    },
    editButton: {
      marginTop: 'auto',
      [maxMd]: {
        paddingTop: '40px',
      },
    },
    formButtons: {
      display: 'flex',

      '& > button': {
        flex: '1',
      },
      '& > button:first-child': {
        marginRight: 5,
      },
      '& > button:last-child': {
        marginLeft: 5,
      },
    },
    serviceAreaMapContain: {
      display: 'flex',
      [minXs]: {
        flex: '1',
      },
      [minLg]: {
        flex: '2',
        maxHeight: '100%',
      },
    },
    mapWrapper: {
      [minMd]: {
        width: '68%',
      },
    },
    serviceAreaControlsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      [maxSm]: {
        borderRadius: 'unset',
      },
    },
    serviceAreaMap: {
      [minMd]: {
        height: '486px',
      },
      width: '100%',
      height: '264px',
    },
    serviceAreaButtonsContain: {
      display: 'flex',
      paddingBottom: '10px',
    },
    serviceAreaButtons: {
      '&:hover': {
        border: 'solid 2px #4d4d4d',
        textTransform: 'none',
        backgroundColor: '#4d4d4d',
        color: '#ffffff',
      },
      border: 'solid 2px #4d4d4d',
      textTransform: 'none',
    },
    serviceAreaButtonsLeft: {
      flex: '1',
      borderBottomRightRadius: '0px',
      borderTopRightRadius: '0px',
    },
    serviceAreaButtonsCenter: {
      '&:hover': {
        borderRight: '1px',
        borderLeft: '1px',
      },
      flex: '1',
      borderRadius: '0px',
      borderRight: '1px',
      borderLeft: '1px',
    },
    serviceAreaButtonsRight: {
      flex: '1',
      borderBottomLeftRadius: '0px',
      borderTopLeftRadius: '0px',
    },
    formRow: {
      width: '100%',
      [minXs]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      '&:first-child': {
        marginTop: -20,
        [minMd]: {
          marginTop: -30,
        },
      },
    },
    formGroup: {
      width: '100%',
      marginTop: 20,
      [minMd]: {
        marginTop: 30,
      },
    },
    serviceAreaCoord: {
      '& label': {
        display: 'none',
      },
    },
    errMsg: {
      color: COLORS.RED,
      fontFamily: FONTS.PRIMARY,
      fontWeight: 300,
      fontSize: '0.875rem',
    },
  };
};

export default styles;
